import {authoxuserController} from "@/http/organization/AuthoxuserController";
import {PrincipalInfoVO} from "@/http/organization/models/PrincipalInfoVO";
import {principalInfoController} from "@/http/organization/PrincipalInfoController";

export const checkAndGetUserInfo = () => {
    const data = authoxuserController.queryCurrentUserDetail()
    return Promise.resolve(data);
};

export const getPrincipalDetail = (principalId: string) => {
    const data = principalInfoController.getById(principalId)
    return Promise.resolve(data);
};
